import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import appshell from "./modules/appshell";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    appshell
  }
});

export default store;
